'use client';

import AutoRepliesPanel from '@/components/AutoRepliesPanel';
import { AUTO_REPLIES_FORM_TITLE } from '@/components/auto-replies-copy';
import Modal from '@/ui/Modal';
import { FC } from 'react';

type AutoRepliesModalProps = {
    isShown: boolean;
    setIsShown: (value: boolean) => void;
};

const AutoRepliesModal: FC<AutoRepliesModalProps> = ({ isShown, setIsShown }) => (
    <Modal
        isShown={isShown}
        setIsShown={setIsShown}
        title={AUTO_REPLIES_FORM_TITLE}
        closable
        className="!h-[calc(100vh-6px)] !w-[calc(100vw-6px)] max-w-none"
    >
        <AutoRepliesPanel />
    </Modal>
);

export default AutoRepliesModal;
